import { type SVGProps } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}

const VisaGreyRegular = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={1333.333}
    height={432}
    viewBox='0 0 1000 324'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d='M631.1 1.1C578.7 6.6 538 32.6 523.1 70c-4.2 10.6-6.1 21.2-6.1 33.8 0 22.7 7.5 39.2 25.8 56.3 10.5 9.9 21.9 17.4 44.2 28.9 33.2 17.2 42 25.4 42 38.7-.1 20.6-27 32.9-64.5 29.4-20.9-2-36.3-6.1-55.9-14.7-5.5-2.4-10.1-4.2-10.4-3.9-.3.2-3.7 15.6-7.7 34.2-6.6 30.7-7.1 33.9-5.7 35.1 4.7 3.7 31.6 10.5 54.7 13.8 17.2 2.5 53 2.5 68 .1 57.7-9.5 94-37.7 104.5-80.9 2.8-11.5 3.5-28.2 1.7-38.4-5.4-29.6-23.5-48.5-70.7-73.4-20.8-11.1-26.5-14.6-32.6-20.2-11.1-10.2-11.2-21.4-.3-31.2 8.6-7.8 19.9-10.9 39.4-10.9 20.1 0 40.1 4 58.3 11.5 4 1.7 7.4 2.9 7.6 2.7.4-.5 13.5-61.7 13.8-64.8.3-2.3-.4-2.7-10.2-5.8-27.5-8.8-59.6-12.1-87.9-9.2zM.6 9.1c-1.3 6.6-1.7 6.3 14.2 10.3 27.9 7.1 55.9 17.5 67.5 25 6.8 4.3 9.1 6.9 12.1 13.6 1.3 3 17.3 62.9 35.4 133l32.9 127.5 43.4.2 43.4.3 64.7-154.8c35.6-85.1 65-155.5 65.4-156.5.6-1.6-1.9-1.7-42.4-1.7h-43l-14 35.2c-7.6 19.4-26.2 66.5-41.3 104.5-15.1 38.1-27.6 69.3-27.9 69.3-.3 0-7.2-35.7-15.4-79.3-19.5-104.4-19.3-103.2-22.2-109-3.8-7.4-10.5-14-17.7-17.3l-6.2-2.9-74.1-.3L1.3 6 .6 9.1zM413.5 7.2c-.2.7-15.1 70.1-33 154.3-18 84.1-32.9 154-33.2 155.3l-.5 2.2h82l1.1-4.8c10-46.9 63.6-297.4 64.5-302l1.4-6.2h-41c-31.8 0-41 .3-41.3 1.2zM853.9 7.6c-6.5 2-13.7 7.1-17.9 12.6-2.5 3.4-21.2 47-64.4 150-33.5 79.9-61.1 146.1-61.4 147.1-.4 1.6 2.1 1.7 42.5 1.7h42.9l8.4-23.5 8.5-23.5h102.4l1.1 5.2c.6 2.9 2.8 13.4 4.9 23.3l3.7 18 37.7.3 37.7.2-.1-2.2c0-1.3-14.5-71.6-32.2-156.3l-32.3-154-38.4-.2c-31-.1-39.4.1-43.1 1.3zm35.6 142.7c6.4 30.7 11.5 56.1 11.2 56.3-.2.2-14.8.3-32.4.2l-32-.3 20.6-56.8c11.3-31.2 20.7-56.4 20.8-56 .1.4 5.4 25.9 11.8 56.6z' />
  </svg>
)

export { VisaGreyRegular }
